import { ACTIVATE_SHIMMER, DEACTIVATE_SHIMMER, CLEAR_STORE } from '../../action-contants';

type ShimmerState = Record<string, boolean>;

const INITIAL_STATE: ShimmerState = {};

export default function shimmerReducer(
  state: ShimmerState = INITIAL_STATE,
  action: { type: string; key?: string }
): ShimmerState {
  switch (action.type) {
    case ACTIVATE_SHIMMER:
      return action.key ? { ...state, [action.key]: true } : state;
    case DEACTIVATE_SHIMMER:
      return action.key ? { ...state, [action.key]: false } : state;
    case CLEAR_STORE:
      return INITIAL_STATE;
    default:
      return state;
  }
}
